import { rest } from 'lodash-es';
import { showToast } from 'vant';
import 'vant/es/toast/style';

export default param => {
  let { type, message, ...rest } = param;
  if (typeof param === "string" ) {
    message = param;
  }
  switch (type){
    case 'success':
      showToast({
        message,
        icon: '/images/toast/success.png',
        ...rest
      });
      break;
    case 'danger':
    case 'fail':
      showToast({
        message,
        icon: '/images/toast/error.png',
        ...rest
      });
      break;
    default:
      showToast({
        message,
      });
      break;
  }
};